import { Component, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
   @Input() formModel:any ={}
   @Input() getAllDropdown:any ={}
 

  constructor(public renderer: Renderer2,) { }

  ngOnInit(): void {
    this.formModel.pricingModel = this.formModel?.pricingModel ?? {};
  }
  // for input keydown ------------------
  onKeydown(event: any, value: any) {
    const element = this.renderer.selectRootElement(value, true);
    if (event.key === "Enter") {
      element.focus();
    }
  }

}
